import { MachineSession } from '../datamodels';
import { routineRepository } from '../repositories/LocalRepositories';

export async function saveRoutine(userId: string, routineName: string, machineSessions: MachineSession[]): Promise<string> {
  return routineRepository.save(userId, routineName, machineSessions);
}
